import { intlPhoneString } from "src/components/js/statics1";
import { newStepLogMessage } from "./stepLog/stepLogMessageClass";

export default class SMSClass {
  constructor(keikkaData, originatorPersonId, token) {
    this.keikkaData = keikkaData;
    this.personId = originatorPersonId;
    this.token = token;
  }

  async sendSMS(puh, msg, socket) {
    puh = intlPhoneString(puh);
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${this.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        msisdn: puh,
        keikkaId: this.keikkaData.keikkaId,
        txt: msg,
        ownerAsiakasId: this.keikkaData.ownerAsiakasId,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/sendSMS/sendSMS",
      requestOptions
    ).catch((err) => {
      console.log("sendSMS error: ", err);
    });
    if (response.ok) {
      //const data = await response.json();
      //console.log("sendSMS response: ", data);
      const sl = newStepLogMessage("SMS lähetetty " + puh, this.personId, this.keikkaData, 14);
      sl.isSystemMessage = true;
      await sl.saveToDB(socket);
      return true;
    } else {
      console.log("sendSMS error");
      return false;
    }
  }
}
